module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2r6r9r-2e4a00019fe8d54871c31a05876b94c0.svg";